module.exports = __webpack_public_path__ + "static/media/roomChangeIcon.b801013c.svg";